export interface FindApplianceModelNumber {
  product: string;
  content?: string[];
  image?: string[];
  comments?: string;
  missingAppliances?: string;
}
